function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS TextField INSTEAD.
import React, { forwardRef, useEffect, useRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import autosize from 'autosize';
import { isEmpty } from 'lodash';
import { fieldProps, getPreferredProp } from "../utils";

/**
 * UUTextField Component
 *
 */
var UUTextField = /*#__PURE__*/forwardRef(function (props, ref) {
  var afterLabelContent = props.afterLabelContent,
    autoFocus = props.autoFocus,
    className = props.className,
    labelClassName = props.labelClassName,
    disabled = props.disabled,
    hideLabel = props.hideLabel,
    hint = props.hint,
    id = props.id,
    inline = props.inline,
    label = props.label,
    placeholder = props.placeholder,
    required = props.required,
    cols = props.cols,
    rows = props.rows,
    style = props.style,
    maxLength = props.maxLength;
  var inputRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      props: props
    };
  });
  useEffect(function () {
    if (inputRef.current) {
      autosize(inputRef.current);
    }
    return function () {
      if (inputRef.current) {
        autosize.destroy(inputRef.current);
      }
    };
  }, []);
  var hasError = getPreferredProp(props, 'invalid') && getPreferredProp(props, 'touched');
  var containerClass = function containerClass() {
    return classNames({
      'mb-2.5': true,
      'pt-1.5': inline,
      'flex flex-row flex-nowrap': inline,
      'opacity-50': disabled
    }, className);
  };
  var labelClass = function labelClass() {
    return classNames(_defineProperty(_defineProperty({
      'flex-none text-right mr-2.5 pt-3 capitalize': true,
      'pt-1.5': inline,
      'text-red': hasError,
      'text-dark-grey': !hasError
    }, labelClassName, !isEmpty(labelClassName)), 'sr-only', hideLabel));
  };
  var textareaWrapperClass = function textareaWrapperClass() {
    return classNames({
      'w-full': true
    });
  };
  var textAreaClass = function textAreaClass() {
    return classNames({
      'bg-white rounded border-solid border box-border text-sm text-text-blue font-regular-font leading-5 p-2 w-full min-h-50px overflow-hidden resize-y-important break-words': true,
      'border-red': hasError,
      'border-light-border-blue': !hasError,
      'opacity-50': disabled
    });
  };
  var errorClass = function errorClass() {
    return classNames({
      'text-red text-xs h-4': true,
      hidden: !hasError,
      visible: hasError
    });
  };
  var ariaLabel = typeof (label || placeholder) === 'string' ? (label || placeholder).toLowerCase() : '';
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass(),
    style: style.container,
    "aria-label": hasError ? "".concat(ariaLabel, " ").concat(getPreferredProp(props, 'error')) : ariaLabel
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: labelClass(),
    style: style.label
  }, label, required && /*#__PURE__*/React.createElement("span", {
    className: "inline-block text-red text-sm ml-1 transform -translate-y-1 align-text-top"
  }, "*")), afterLabelContent && /*#__PURE__*/React.createElement("div", {
    className: "mb-4 mt-2 font-regular-font text-dark-grey"
  }, afterLabelContent), /*#__PURE__*/React.createElement("div", {
    className: textareaWrapperClass()
  }, /*#__PURE__*/React.createElement("textarea", {
    className: textAreaClass(),
    id: id,
    value: getPreferredProp(props, 'value'),
    onChange: getPreferredProp(props, 'onChange'),
    onBlur: getPreferredProp(props, 'onBlur'),
    onFocus: getPreferredProp(props, 'onFocus'),
    placeholder: placeholder,
    name: getPreferredProp(props, 'name'),
    disabled: disabled,
    autoFocus: autoFocus,
    style: {
      resize: 'vertical !important'
    },
    cols: cols,
    rows: rows,
    ref: inputRef,
    maxLength: maxLength
  }), /*#__PURE__*/React.createElement("div", {
    className: "mt-0.5 text-dark-grey text-xs italic leading-4",
    style: style.hint
  }, hint), /*#__PURE__*/React.createElement("div", {
    className: errorClass(),
    style: style.error
  }, getPreferredProp(props, 'error'))));
});
UUTextField.propTypes = _objectSpread({
  /** id for reference */
  id: PropTypes.string.isRequired,
  /** className for reference */
  className: PropTypes.string,
  /**
   * Override the inline-styles of the elements || **Not Recommended**
   * <br> ***note: currently overwritten by mysterious inline styles in `textarea`***
  */
  style: PropTypes.shape({
    container: PropTypes.object,
    label: PropTypes.object,
    text: PropTypes.object,
    hint: PropTypes.object,
    error: PropTypes.object
  }),
  /** label text for button */
  label: PropTypes.node.isRequired,
  /** insert content after label */
  afterLabelContent: PropTypes.node,
  /** Should the label be displayed inline with the input? */
  inline: PropTypes.bool,
  /** Is the input disabled? */
  disabled: PropTypes.bool,
  /** Placeholder text */
  placeholder: PropTypes.string,
  /** Should the label be hidden? */
  hideLabel: PropTypes.bool,
  /** Should the UUtextfield be focused on load? */
  autoFocus: PropTypes.bool,
  /** Help text displayed below the input */
  hint: PropTypes.node,
  /** Is the field required */
  required: PropTypes.bool,
  /** number of columns for text area */
  cols: PropTypes.number,
  /** number of rows for text area */
  rows: PropTypes.number,
  /** max characters for text area */
  maxLength: PropTypes.number
}, fieldProps);
UUTextField.defaultProps = {
  afterLabelContent: null,
  ariaLabel: null,
  autoFocus: false,
  className: '',
  disabled: false,
  hideLabel: false,
  hint: '',
  inline: false,
  labelClassName: '',
  placeholder: '',
  required: false,
  cols: 50,
  rows: 4,
  style: {
    container: {},
    label: {},
    text: {},
    hint: {},
    error: {}
  },
  maxLength: null
};
export default UUTextField;